export const TITLE_NAVBAR='Current Air Quality Index';

export const AUTOCOMPLETE_API_KEY = 'e94fd042131f45f18a7a4c89d5b8276d';
export const AIR_QUALITY_API_KEY = '2f9f437fc127edba8c7068fe3bd209f4';

export const TITLE_INTRODUCTION='Respirar...';
export const INTRODUCTION_PARAGRAPH = 'Te guste o no, estás obligado a respirar el aire que te rodea. Los datos de calidad del aire ayudan a visualizar y cuantificar la contaminación del aire ambiental de su región. Entonces, ¿cómo es el aire en tu ciudad?'
export const AQI_CAPTIOS = {
    unit: 'μg/m3',
    co: ['CO', '(Monóxido de Carbono)'],
    no: ['NO','(Monóxido de Nitrógeno)'],
    no2: ['NO','(Dióxido de Nitrógeno)'],
    o3: ['O3','(Ozono)'],
    so2: ['SO2','(Dióxido de Azufre)'],
    pm2_5: ['PM2.5','(Partículas de menos de 2.5 µm)'],
    pm10: ['PM10','(Partículas de menos de 10µm)'],
    nh3: ['NH3','(Amoníaco)']
};

export const infoText={
    1:'La calidad del aire es buena y existe poco o ningún riesgo para la salud. Se puede realizar cualquier actividad al aire libre.',
    2:'La calidad del aire es aceptable, sin embargo, en como se detectaron algunos contaminantes, las personas que perteneces a los grupos sensibles pueden presentar síntomas moderados. Los grupos sensibles deben considerar limitar los esfuerzos prolongados al aire libre',
    3:'Las personas que pertenecen a los grupos sensibles pueden experimentar efectos en la salud. El público en general usualmente no es afectado. Los grupos sensibles deben limitar los esfuerzos prolongados al aire libre.',
    4:'Todos pueden experimentar efectos en la salud. Quienes pertenecen a los grupos sensibles pueden experimentar efectos graves en la salud. Los grupos sensibles deben evitar el esfuerzo prolongado al aire libre. La población en general debe limitar el esfuerzo prolongado al aire libre.',
    5:'Toda la población tiene probabilidades de ser afectada. La población en general debe suspender los esfuerzos al aire libre.'
}